<template>
  <CaseStudy
    title="LIBRA"
    :logo="require('@/assets/logos/libra.png')"
    :thumbnail="require('@/assets/screenshots/libra.png')"
    iframeLink="https://iframe.bubblemaps.io/map/mkdTyfVRXVh9XH01TmxY?partnerId=demo"
    threadLink="https://x.com/bubblemaps/status/1890567816752873794"
    isOdd
    :featuredIn="[
      {
        name: 'The New York Times',
        logo: require('@/assets/logos/medias/newyorktimes.png'),
        link: 'https://www.nytimes.com/2025/02/28/world/americas/argentina-crypto-scandal-president.html',
        color: '#000000',
      },
      {
        name: 'CoinDesk',
        logo: require('@/assets/logos/medias/coindesk.png'),
        link: 'https://www.coindesk.com/policy/2025/02/16/argentina-opposition-threatens-milei-with-impeachment-over-libra-token-controversy-reuters',
        color: '#F8BF1E',
      },
      {
        name: 'Wikipedia',
        logo: require('@/assets/logos/medias/wikipedia.png'),
        link: 'https://en.wikipedia.org/wiki/$Libra_cryptocurrency_scandal',
      },
    ]"
  >
    How LIBRA team made $100M+ by draining USDC from Meteora LP, via a
    <b>cluster of addresses holding 82% of the supply</b>
  </CaseStudy>
</template>

<script>
import CaseStudy from "@/components/organisms/CaseStudies/CaseStudy.vue";

export default {
  components: {
    CaseStudy,
  },
};
</script>
